import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumDiscountTierBasis implements BaseEnumType {
  private static allValues: EnumDiscountTierBasis[] = []; // make sure this is top-most
  
  public static none = new EnumDiscountTierBasis(0, "None", "enum_discount_tier_basis_none");
  public static byLineQuantity = new EnumDiscountTierBasis(1, "ByLineQuantity", "enum_discount_tier_basis_by_line_quantity");
  public static byLineAs9Gallons = new EnumDiscountTierBasis(2, "ByLineAs9Gallons", "enum_discount_tier_basis_by_line_as9_gallons");
  public static byPricingCategoryQuantity = new EnumDiscountTierBasis(3, "ByPricingCategoryQuantity", "enum_discount_tier_basis_by_pricing_category_quantity");
  public static byPricingCategoryAs9Gallons = new EnumDiscountTierBasis(4, "ByPricingCategoryAs9Gallons", "enum_discount_tier_basis_by_pricing_category_as9_gallons");
  public static byLineAsLitres = new EnumDiscountTierBasis(5, "ByLineAsLitres", "enum_discount_tier_basis_by_line_as_litres");
  public static byPricingCategoryAsLitres = new EnumDiscountTierBasis(6, "ByPricingCategoryAsLitres", "enum_discount_tier_basis_by_pricing_category_as_litres");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDiscountTierBasis.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumDiscountTierBasis.none; }
  public isByLineQuantity() { return this === EnumDiscountTierBasis.byLineQuantity; }
  public isByLineAs9Gallons() { return this === EnumDiscountTierBasis.byLineAs9Gallons; }
  public isByPricingCategoryQuantity() { return this === EnumDiscountTierBasis.byPricingCategoryQuantity; }
  public isByPricingCategoryAs9Gallons() { return this === EnumDiscountTierBasis.byPricingCategoryAs9Gallons; }
  public isByLineAsLitres() { return this === EnumDiscountTierBasis.byLineAsLitres; }
  public isByPricingCategoryAsLitres() { return this === EnumDiscountTierBasis.byPricingCategoryAsLitres; }

  public static getValues(): readonly EnumDiscountTierBasis[] {
    return EnumDiscountTierBasis.allValues;
  }

  public static getValuesExcept0(): readonly EnumDiscountTierBasis[] {
    return EnumDiscountTierBasis.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDiscountTierBasis {
    const found = EnumDiscountTierBasis.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDiscountTierBasis - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDiscountTierBasis): EnumDiscountTierBasis {
    const found = name ? EnumDiscountTierBasis.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDiscountTierBasis - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumDiscountTierBasis>): boolean {
    return this.key === other?.key;
  }
}